<template>
    <div class="lg:w-3/12 md:w-4/12 flex py-2 px-3 sm:w-6/12 w-full">
        <span class="w-8 mt-1">
          <slot></slot>
        </span>
         <p class="w-full">
           <label class="opacity-50 text-sm block w-full">{{ title }}</label>
           <span class="text-sm block w-full font-semibold capitalize">{{ label }}</span>
         </p>
      </div>
</template>

<script>
    export default {
        props:["title", "img", "label"],
        mounted() {
            // this.$ref.imageIndicator.src = require("@/assets/images/booking-management/svgs/port-of-origin.svg")
        },
        computed: {
            imgSrc(){
                return "'"+this.img+"'"
            }
        },
    }
</script>

<style lang="scss" scoped>

</style>